<template>
  <div class="painel-gestao">
    <header class="cabecalho">
      <div>
        <h2>Visão geral dos projetos</h2>
        <p>Acompanhe a execução do portfólio Cidade Empreendedora e PDM.</p>
      </div>
      <button type="button" @click="carregarPainel" :disabled="carregando">
        {{ carregando ? "Atualizando..." : "Atualizar dados" }}
      </button>
    </header>

    <div class="painel-blocos">
      <div class="filtros-container">
        <div class="filtros-header">
          <div>
            <h3>Filtros</h3>
            <p>Refine a visualização dos dados por critérios específicos</p>
          </div>
          <button
            type="button"
            class="filtros-clear"
            @click="limparFiltros"
            v-if="municipioFiltro.municipio"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6 18L18 6M6 6l12 12"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Limpar filtros
          </button>
        </div>
        <div class="filtros-grid">
          <div class="filtro-campo">
            <label for="filtro-municipio">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <circle
                  cx="12"
                  cy="10"
                  r="3"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
              Município
            </label>
            <div class="filtro-input-wrapper">
              <ComboboxMunicipio
                ref="filtroMunicipio"
                :filter="municipioFiltro"
                clearable
                @changeCity="aoAlterarMunicipio"
                :noLabel="true"
                filled
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <section class="painel-blocos" v-if="painel">
      <div class="painel-card">
        <header class="painel-card__cabecalho">
          <h3>Indicadores gerais</h3>
          <p>Resumo do andamento dos projetos monitorados.</p>
        </header>
        <div class="indicadores">
          <article>
            <h4>Total de projetos</h4>
            <strong>{{ painel.totalProjetos }}</strong>
            <span>Projetos cadastrados na base</span>
          </article>
          <article>
            <h4>No prazo</h4>
            <strong>{{ painel.projetosNoPrazo }}</strong>
            <span>Saúde saudável ou em dia</span>
          </article>
          <article>
            <h4>Atrasados</h4>
            <strong>{{ painel.projetosAtrasados }}</strong>
            <span>Projetos marcados como críticos</span>
          </article>
          <article>
            <h4>Concluídos</h4>
            <strong>{{ painel.projetosConcluidos }}</strong>
            <span>Encerrados com sucesso</span>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ComboboxMunicipio from "@/modules/city/components/ComboboxSingle.vue";
import { buscarPainel } from "../services/api";

export default {
  name: "PainelGestaoProjetos",
  components: {
    ComboboxMunicipio,
  },
  data() {
    return {
      carregando: false,
      erro: "",
      painel: null,
      filtros: {
        siglaEstado: "",
        idMunicipio: undefined,
      },
      municipioFiltro: {
        municipio: null,
      },
    };
  },
  computed: {
    ...mapGetters(["uf"]),
  },
  async created() {
    this.filtros.siglaEstado = this.uf || "";
    this.tentarSincronizarMunicipio();
    await this.carregarPainel();
  },
  watch: {
    "filtros.idMunicipio": {
      handler() {
        this.carregarPainel();
        this.$nextTick(() => this.tentarSincronizarMunicipio());
      },
    },
  },
  methods: {
    async carregarPainel() {
      try {
        this.carregando = true;
        this.erro = "";
        const { data } = await buscarPainel(this.filtros);
        this.painel = data;
      } catch (error) {
        this.erro = "Falha ao carregar o painel de projetos.";
        // eslint-disable-next-line no-console
        console.error("[gestao-projetos] painel", error);
      } finally {
        this.carregando = false;
      }
    },
    aoAlterarMunicipio(municipio) {
      if (Array.isArray(municipio)) {
        const selecionado = municipio.find(
          (item) => item && (item.municipioId || item.id)
        );
        this.filtros.idMunicipio = selecionado
          ? Number(selecionado.municipioId || selecionado.id)
          : undefined;
      } else if (municipio && typeof municipio === "object") {
        this.filtros.idMunicipio =
          municipio.municipioId || municipio.id || undefined;
      } else {
        this.filtros.idMunicipio = municipio || undefined;
      }
      this.municipioFiltro.municipio =
        municipio && typeof municipio === "object" ? municipio : null;
    },
    limparFiltros() {
      this.municipioFiltro.municipio = null;
      this.filtros.idMunicipio = undefined;
      if (this.$refs.filtroMunicipio) {
        this.$refs.filtroMunicipio.clearSelection();
      }
    },
    tentarSincronizarMunicipio(tentativa = 0) {
      if (tentativa > 10) return;
      if (!this.filtros.idMunicipio) {
        this.municipioFiltro.municipio = null;
        return;
      }
      const combobox = this.$refs.filtroMunicipio;
      const lista = combobox?.municipios;
      if (Array.isArray(lista) && lista.length) {
        const encontrado = lista.find(
          (item) => item.municipioId === this.filtros.idMunicipio
        );
        if (encontrado) {
          this.municipioFiltro.municipio = encontrado;
          return;
        }
      }
      setTimeout(() => this.tentarSincronizarMunicipio(tentativa + 1), 200);
    },
    formatarData(valor) {
      if (!valor) return "Sem data";
      const data = new Date(valor);
      if (Number.isNaN(data.getTime())) return "Sem data";
      return data.toLocaleDateString("pt-BR");
    },
    formatarPeriodo(inicio, fim) {
      if (!inicio && !fim) return "Sem data";
      const inicioFmt = inicio ? this.formatarData(inicio) : null;
      const fimFmt = fim ? this.formatarData(fim) : null;
      if (!inicioFmt || inicioFmt === "Sem data") return fimFmt || "Sem data";
      if (!fimFmt || fimFmt === "Sem data") return inicioFmt;
      return `${inicioFmt} - ${fimFmt}`;
    },
  },
};
</script>

<style scoped>
.painel-gestao {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.cabecalho {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cabecalho h2 {
  margin: 0;
  font-size: 2rem;
  color: #0f172a;
}

.cabecalho button {
  background: #2563eb;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 18px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s ease;
}

.cabecalho button:hover {
  background: #1d4ed8;
}

.filtros-container {
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  margin-bottom: 4px;
}

.filtros-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 20px;
  gap: 16px;
}

.filtros-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #0f172a;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filtros-header p {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 0.9rem;
  line-height: 1.4;
}

.filtros-clear {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #64748b;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
}

.filtros-clear:hover {
  background: #e2e8f0;
  color: #475569;
  border-color: #cbd5e1;
}

.filtros-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.filtro-campo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filtro-campo label {
  font-size: 0.9rem;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 8px;
}

.filtro-campo label svg {
  color: #0074cc;
}

.filtro-input-wrapper {
  position: relative;
}

.filtro-campo :deep(.v-input__control),
.filtro-campo :deep(.v-field) {
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #ffffff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  transition: all 0.2s ease;
}

.filtro-campo :deep(.v-field:hover) {
  border-color: #0074cc;
  box-shadow: 0 2px 6px rgba(0, 116, 204, 0.1);
}

.filtro-campo :deep(.v-field--focused) {
  border-color: #0074cc;
  box-shadow: 0 0 0 3px rgba(0, 116, 204, 0.1);
}

.filtro-campo :deep(.v-field__input) {
  padding: 12px 16px;
  font-size: 0.95rem;
}

.filtro-campo :deep(.combobox-municipio .v-field) {
  min-height: 48px;
}

.filtro-campo :deep(.combobox-municipio .v-field__input),
.filtro-campo :deep(.combobox-municipio input) {
  min-height: 48px;
  padding: 8px 16px;
}

.filtros {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 16px;
  background: #fff;
  border-radius: 20px;
  padding: 22px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.1);
}

.campo {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.campo label {
  font-size: 0.9rem;
  color: #475569;
  font-weight: 600;
}

.campo :deep(.v-input__control),
.campo :deep(.v-field) {
  border-radius: 10px;
  border: 1px solid #cbd5f5;
  background: #fff;
  box-shadow: none;
}

.campo :deep(.v-label) {
  display: none;
}

.campo :deep(.v-field__input) {
  border-radius: 10px;
  padding: 10px 12px;
}

.painel-blocos {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.painel-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 28px;
  box-shadow: 0 20px 45px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.painel-card__cabecalho h3 {
  margin: 0;
  font-size: 1.35rem;
  color: #0f172a;
}

.painel-card__cabecalho p {
  margin: 6px 0 0;
  color: #475569;
  font-size: 0.95rem;
}

.indicadores {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 18px;
}

.indicadores article {
  background: linear-gradient(
    145deg,
    rgba(37, 99, 235, 0.95),
    rgba(14, 165, 233, 0.9)
  );
  color: #fff;
  padding: 20px;
  border-radius: 18px;
  box-shadow: 0 12px 28px rgba(37, 99, 235, 0.25);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.indicadores h4 {
  margin: 0;
  font-size: 1.05rem;
}

.indicadores strong {
  font-size: 2.2rem;
  font-weight: 700;
}

.indicadores span {
  font-size: 0.85rem;
  opacity: 0.85;
}

.erro {
  padding: 14px 18px;
  border-radius: 10px;
  background: #fee2e2;
  color: #b91c1c;
}

@media (max-width: 768px) {
  .painel-card {
    padding: 22px;
    border-radius: 20px;
  }

  .indicadores {
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  }

  .filtros-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .filtros-clear {
    align-self: flex-start;
  }

  .filtros-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }

  .filtros-container {
    padding: 16px;
  }
}
</style>
